package com.brdgwtr.designsystem.tokens.internal

internal object BwZoomScaleTokens {
    val zoomS = 1.025f
    val zoomM = 1.05f
    val zoomL = 1.075f
}
